/** Traženje jednako prihvaća Jakšinec/Jaksinec i Đ/đ/d. */
export function normalizirajTekst(tekst) {
  return String(tekst ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[đĐ]/g, 'd')
    .toLowerCase();
}

export const FILTRI = [
  { kljuc: 'svi', naziv: 'Svi zapisi', test: () => true },
  {
    kljuc: 'potvrda',
    naziv: 'Za potvrdu',
    test: (z) => ['predlozeno', 'smjesteno'].includes(z.status),
  },
  { kljuc: 'bez', naziv: 'Bez pozicije', test: (z) => z.status === 'ne' },
  {
    kljuc: 'potvrdjeno',
    naziv: 'Potvrđeno',
    test: (z) => z.status === 'potvrdjeno',
  },
  {
    kljuc: 'nejasno',
    naziv: 'Za provjeru',
    test: (z) => z.stanje === 'nejasno',
  },
];

export function filtrirajZapise(
  zapisi,
  { upit = '', naselje = '', filter = 'svi' } = {},
) {
  const trazeno = normalizirajTekst(upit.trim()).split(/\s+/).filter(Boolean);
  const provjera =
    FILTRI.find((f) => f.kljuc === filter)?.test ?? FILTRI[0].test;
  return zapisi.filter((z) => {
    if (naselje && (naselje === 'bez' ? !!z.naselje : z.naselje !== naselje))
      return false;
    if (!provjera(z)) return false;
    const tekst = normalizirajTekst(
      `${z.adresa ?? ''} ${z.ime ?? ''} ${z.prezime ?? ''} ${z.nositelj_ime ?? ''} ${z.nositelj_prezime ?? ''} ${z.redni_broj ?? ''}`,
    );
    return trazeno.every((rijec) => tekst.includes(rijec));
  });
}

/** Kućni broj ostaje tekst; prirodna usporedba razlikuje 13, 13a i 159/1. */
export function poredajKucanstva(zapisi) {
  return [...zapisi].sort(
    (a, b) =>
      String(a.naselje ?? '').localeCompare(String(b.naselje ?? ''), 'hr') ||
      String(a.kucni_broj ?? '').localeCompare(
        String(b.kucni_broj ?? ''),
        'hr',
        { numeric: true },
      ),
  );
}

export function prebrojiStatuse(zapisi) {
  return {
    ukupno: zapisi.length,
    potvrdjeno: zapisi.filter((z) => z.status === 'potvrdjeno').length,
    potvrda: zapisi.filter((z) =>
      ['predlozeno', 'smjesteno'].includes(z.status),
    ).length,
    bez: zapisi.filter((z) => z.status === 'ne').length,
  };
}

export function procitajKoordinatu(vrijednost) {
  const tekst = String(vrijednost ?? '').trim();
  if (!/^-?\d+(?:[.,]\d+)?$/.test(tekst)) return null;
  const broj = Number(tekst.replace(',', '.'));
  return Number.isFinite(broj) ? broj : null;
}

export function provjeriKoordinate(sirina, duzina) {
  const lat = procitajKoordinatu(sirina);
  const lng = procitajKoordinatu(duzina);
  if (lat == null || lng == null)
    throw new Error('Upiši obje koordinate kao decimalne brojeve.');
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180)
    throw new Error('Koordinate su izvan dopuštenog raspona.');
  return [lat, lng];
}
